// source: src/common/quota/quota_summary.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.loupe.common.quota.QuotaSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.quota.QuotaSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.quota.QuotaSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.quota.QuotaSummary.displayName = 'proto.loupe.common.quota.QuotaSummary';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.quota.QuotaSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.quota.QuotaSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.quota.QuotaSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.quota.QuotaSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    actual: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    baseline: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    quarter: jspb.Message.getFieldWithDefault(msg, 5, 0),
    monthIdx: jspb.Message.getFieldWithDefault(msg, 6, 0),
    year: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.quota.QuotaSummary}
 */
proto.loupe.common.quota.QuotaSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.quota.QuotaSummary;
  return proto.loupe.common.quota.QuotaSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.quota.QuotaSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.quota.QuotaSummary}
 */
proto.loupe.common.quota.QuotaSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setActual(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBaseline(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuarter(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthIdx(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.quota.QuotaSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.quota.QuotaSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.quota.QuotaSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.quota.QuotaSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActual();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getBaseline();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getQuarter();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMonthIdx();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getYear();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp end_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.quota.QuotaSummary.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
*/
proto.loupe.common.quota.QuotaSummary.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
 */
proto.loupe.common.quota.QuotaSummary.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.quota.QuotaSummary.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp start_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.quota.QuotaSummary.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
*/
proto.loupe.common.quota.QuotaSummary.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
 */
proto.loupe.common.quota.QuotaSummary.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.quota.QuotaSummary.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double actual = 3;
 * @return {number}
 */
proto.loupe.common.quota.QuotaSummary.prototype.getActual = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
 */
proto.loupe.common.quota.QuotaSummary.prototype.setActual = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double baseline = 4;
 * @return {number}
 */
proto.loupe.common.quota.QuotaSummary.prototype.getBaseline = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
 */
proto.loupe.common.quota.QuotaSummary.prototype.setBaseline = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 quarter = 5;
 * @return {number}
 */
proto.loupe.common.quota.QuotaSummary.prototype.getQuarter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
 */
proto.loupe.common.quota.QuotaSummary.prototype.setQuarter = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 month_idx = 6;
 * @return {number}
 */
proto.loupe.common.quota.QuotaSummary.prototype.getMonthIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
 */
proto.loupe.common.quota.QuotaSummary.prototype.setMonthIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 year = 7;
 * @return {number}
 */
proto.loupe.common.quota.QuotaSummary.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.quota.QuotaSummary} returns this
 */
proto.loupe.common.quota.QuotaSummary.prototype.setYear = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


goog.object.extend(exports, proto.loupe.common.quota);
